import { Component, OnInit } from '@angular/core';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { AppConfig } from 'src/app/config';
import { custom } from 'devextreme/ui/dialog';
import { DigitalnaPlocaService } from './digitalna-ploca.service';

@Component({
  selector: 'app-digitalna-ploca',
  templateUrl: './digitalna-ploca.component.html',
  styleUrls: ['./digitalna-ploca.component.scss'],
  providers: [DigitalnaPlocaService]
})
export class DigitalnaPlocaComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  
  tabovi: any = [
    { id: 1, naziv: 'Obavijesti' },
    { id: 2, naziv: 'Dokumenti' }
  ];

  sviDokumenti: any = [];
  slikaa: any;
  filee: any;
  URL: any = AppConfig.IPfile;
  sveObavijesti: any = [];
  prikazi_gumb: any = true;
  podaciZaglavlje: any = [];
  poruka: string;
  naslov: string;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: DigitalnaPlocaService) {

    this.onShowing = this.onShowing.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().digitalnaPloca;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  dohvatiObavijesti(){
    this.sveObavijesti = [];
    this.poruka = 'Učitavanje...';
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
    };
    this.service.dohvatiObavijesti(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        //this.sveObavijesti = res.data;
        let brojac = 1;
        for (let data of res.data) {
          let arr = { ...data, redni_broj: brojac++ };
          this.sveObavijesti.push(arr);
        }
        //console.log(this.sveObavijesti);
      }else{
        notify(res.message, 'error', 3000);
      }
      if (res.data.length > 0) {
        this.poruka = 'Učitavanje...';
      }else{
        this.poruka = 'Nema podataka za prikaz!';
      } 
    });
  }

  fileChangeSlika(event) {
    //console.log(event)
    this.slikaa = event.target.files;
    //console.log(this.slikaa);
    //console.log('podaciZaglavlje: ', this.podaciZaglavlje);
    /* kod "uređivanja" kad odabere dokument šalje se odmah na api za update jer je bilo problema pošto forma u devextreme nije skužila da je bilo izmjene 
    (ako ostali podaci nisu mjenjani već se samo dodaje dokument) pa se nije htio pozvati api tj. funkcija (onRowUpdated) urediObavijest  */
    if (this.podaciZaglavlje.idobavijest) {
      let fileList: FileList = this.slikaa;
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('idkorisnik', this.idkorisnik);
      formData.append('idfirma', this.idfirma);
      formData.append('access_token', this.access_token);
      formData.append('datoteka', file);
      formData.append('nazivtablice', 'digitalnaploca');
      formData.append('ud_oznaka', '1');
      formData.append('idobavijest', this.podaciZaglavlje.idobavijest);
      formData.append('iduploaddatoteka', this.podaciZaglavlje.iduploaddatoteka);
      formData.append('ob_datum', moment(this.podaciZaglavlje.ob_datum).format('YYYY-MM-DD')),
      formData.append('ob_naslov', this.podaciZaglavlje.ob_naslov);
      formData.append('ob_sadrzaj', this.podaciZaglavlje.ob_sadrzaj);
      this.service.urediObavijest(formData).subscribe((res) => {
        //console.log(res);
        this.dohvatiObavijesti();
        if (res.success === true) {
          this.prikazi_gumb = false;
          notify('Uspješno ste dodali privitak.', 'success', 3000);
        }else{
          notify(res.message, 'error', 3000);
        }
      });
    }
  }

  dodajObavijest(e) {
    //console.log(e);
    let fileList: FileList;
    let file: File;
    if (this.slikaa) {
      fileList = this.slikaa;
      file = fileList[0];
    }
    let formData: FormData = new FormData();
    formData.append('idkorisnik', this.idkorisnik);
    formData.append('idfirma', this.idfirma);
    formData.append('access_token', this.access_token);
    formData.append('datoteka', file);
    formData.append('nazivtablice', 'digitalnaploca');
    formData.append('ud_oznaka', '1');
    formData.append('ob_datum', moment(e.data.ob_datum).format('YYYY-MM-DD')),
    formData.append('ob_naslov', e.data.ob_naslov);
    formData.append('ob_sadrzaj', e.data.ob_sadrzaj);
    this.service.dodajObavijest(formData).subscribe((res) => {
      //console.log(res);
      this.dohvatiObavijesti();
      if (res.success === true) {
        notify('Uspješno ste dodali obavijest.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  urediObavijest(e) {
    //console.log(e);
    let fileList: FileList;
    let file: File;
    if (this.slikaa) {
      fileList = this.slikaa;
      file = fileList[0];
    }
    let formData: FormData = new FormData();
    formData.append('idkorisnik', this.idkorisnik);
    formData.append('idfirma', this.idfirma);
    formData.append('access_token', this.access_token);
    formData.append('datoteka', file);
    formData.append('nazivtablice', 'digitalnaploca');
    formData.append('ud_oznaka', '1');
    formData.append('idobavijest', e.data.idobavijest);
    formData.append('iduploaddatoteka', e.data.iduploaddatoteka);
    formData.append('ob_datum', moment(e.data.ob_datum).format('YYYY-MM-DD')),
    formData.append('ob_naslov', e.data.ob_naslov);
    formData.append('ob_sadrzaj', e.data.ob_sadrzaj);
    this.service.urediObavijest(formData).subscribe((res) => {
      //console.log(res);
      this.dohvatiObavijesti();
      if (res.success === true) {
        notify('Uspješno ste uredili obavijest.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  obrisiObavijest(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idobavijest: e.data.idobavijest,
      iddokument: e.data.iddokument,
      iduploaddokument: e.data.iduploaddokument
    }
    //console.log(podaciZaSlanje);
    this.service.obrisiObavijest(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.dohvatiObavijesti();
      if (res.success === true) {
        notify('Obavijest uspješno obrisana.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  obrisiFile(){
    let myDialog = custom({
      title: "Brisanje",
      messageHtml: "Jeste li sigurni da želite obrisati privitak?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },{
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      //console.log(dialogResult.buttonText);
      if(dialogResult.buttonText === 'DA'){
        let podaciZaSlanje = {
          idfirma: this.idfirma,
          idkorisnik: this.idkorisnik,
          access_token: this.access_token,
          iddokument: this.podaciZaglavlje.iddokument,
          iduploaddokument: this.podaciZaglavlje.iduploaddokument
        }
        //console.log(podaciZaSlanje);
        this.service.obrisiDokument(podaciZaSlanje).subscribe((res) => {
          //console.log(res);
          this.dohvatiObavijesti();
          if (res.success === true) {
            this.prikazi_gumb = true;
            notify('Privitak uspješno obrisan.', 'success', 3000);
          }else{
            notify(res.message, 'error', 3000);
          }
        });
      }else{  }
    });
  }

  dohvatiDokumente(){
    this.sviDokumenti = [];
    this.poruka = 'Učitavanje...';
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
    };
    this.service.dohvatiDokumente(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        //this.sviDokumenti = res.data;
        let brojac = 1;
        for (let data of res.data) {
          let arr = { ...data, redni_broj: brojac++ };
          this.sviDokumenti.push(arr);
        }
        //console.log(this.sviDokumenti);
      }else{
        notify(res.message, 'error', 3000);
      }
      if (res.data.length > 0) {
        this.poruka = 'Učitavanje...';
      }else{
        this.poruka = 'Nema podataka za prikaz!';
      } 
    });
  }

  fileChangeDoc(event) {
    //console.log(event)
    this.filee = event.target.files;
    //console.log(this.filee);
  }

  dodajDokument(e){
    //console.log(e);
    let fileList: FileList = this.filee;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('idkorisnik', this.idkorisnik);
      formData.append('idfirma', this.idfirma);
      formData.append('access_token', this.access_token);
      formData.append('datoteka', file);
      formData.append('nazivtablice', 'digitalnaploca');
      formData.append('ud_oznaka', '0');
      formData.append('do_naziv', e.data.do_naziv);
      this.service.dodajDokument(formData).subscribe((res) => {
        //console.log(res);
        if (res.success == true) {
          notify('Uspješno ste dodali dokument...', 'success', 3000);
          this.dohvatiDokumente();
        } else {
          notify(res.message, 'error', 3000);
        }
      });
    }
  }

  obrisiDokument(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      iddokument: e.data.iddokument,
      iduploaddokument: e.data.iduploaddokument
    }
    //console.log(podaciZaSlanje);
    this.service.obrisiDokument(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Dokument uspješno obrisan.', 'success', 3000);
        this.dohvatiDokumente();
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }


  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onShowing(e: any){
		e.component.option("title", this.naslov);
	}
	
	onInitNewRow(e: any){
		//console.log(e);
		this.naslov = 'Dodaj obavijest';
    e.data.ob_datum = new Date();
    this.podaciZaglavlje = [];
    this.prikazi_gumb = true;
	}

  onInitNewRow2(e: any){
		//console.log(e);
		this.naslov = 'Dodaj dokument';
	}

	onEditingStart(e) {
		//console.log(e);
    this.naslov = 'Uredi obavijest';
    this.podaciZaglavlje = e.data;
    this.prikazi_gumb = true;
    if (e.data.ud_nazivdokumenta_orig != null) {
      this.prikazi_gumb = false;
    }
	}

  ngOnInit(): void {
    this.dohvatiObavijesti();
    this.dohvatiDokumente();
  }

}
